export const CLASS_NAME = 'basic-info-form'
